export const API_BASE_URL = 'https://recc.org.in/api';
export const BASE_URL = 'https://recc.org.in';